module.exports = __webpack_public_path__ + "media/purple-finch-1.0473fe81.mp3";